module.exports = __webpack_public_path__ + "static/img/logo-red@2x.5c5d00ff.png";